var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"uibutton",class:{
          'uibutton--loading': _vm.loading,
          'uibutton--reverse': _vm.reverse,
          'uibutton--compact': _vm.compact,
        },style:({ height: _vm.h, width: _vm.w }),attrs:{"id":_vm.id,"disabled":_vm.disabled,"type":_vm.type}},_vm.$listeners),[_c('span',[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"loader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }